import React from "react";
import { Formik } from "formik";
import {
  MimaButton,
  MimaDropdown,
  MimaInput,
  MimaText,
  Modal,
} from "../../../components";

const CreateAd = ({
  loading,
  onSubmit,
  closeModal,
  currencyCodes,
  validationSchema,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb="7">
        Create Ad
      </MimaText>
      <Formik
        initialValues={{
          username: "",
          from: "",
          to: "",
          rate: 0,
          availableAmount: 0,
          minPerSale: 0,
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <div>
            <MimaInput
              labelTitle="Username"
              variant="form2"
              name="username"
              type="text"
              value={values.username}
              placeholder="Enter Username"
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.username}
              touched={touched.username}
            />
            <div className="modal__beside">
              <MimaDropdown
                labelTitle="Currency From"
                variant="filterForm"
                name="from"
                placeholder="Select Currency"
                data={currencyCodes}
                value={values.from}
                currentValue={values.from}
                onChange={(data) => {
                  setFieldValue("from", data.key);
                }}
                onBlur={handleBlur}
                error={errors.from}
                touched={touched.from}
                width={18}
              />
              <MimaDropdown
                labelTitle="Currency To"
                variant="filterForm"
                name="to"
                placeholder="Select Currency"
                data={currencyCodes}
                value={values.to}
                currentValue={values.to}
                onChange={(data) => {
                  setFieldValue("to", data.key);
                }}
                onBlur={handleBlur}
                error={errors.to}
                touched={touched.to}
                width={18}
              />
            </div>
            <div className="modal__beside">
              <MimaInput
                labelTitle="Rate"
                variant="form2"
                name="rate"
                type="number"
                value={values.rate}
                placeholder="Enter Rate"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.rate}
                touched={touched.rate}
                width={18}
              />
              <MimaInput
                labelTitle="Available Amount"
                variant="form2"
                name="availableAmount"
                type="number"
                value={values.availableAmount}
                placeholder="Enter available amount"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.availableAmount}
                touched={touched.availableAmount}
                width={18}
              />
            </div>

            <MimaInput
              labelTitle="Min per sale"
              variant="form2"
              name="minPerSale"
              type="number"
              value={values.minPerSale}
              placeholder="Enter min per sale"
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.minPerSale}
              touched={touched.minPerSale}
            />

            <MimaButton
              title="Save"
              width={38}
              // buttonColor="var(--color-dark)"
              onClick={handleSubmit}
              loading={loading}
            />
          </div>
        )}
      </Formik>
    </Modal>
  );
};
export default CreateAd;
